module.exports = ".ibox-content {\n  background-color: transparent;\n  border: 0;\n  padding: 0; }\n\n.ibox-content.sk-loading::after {\n  background-color: rgba(241, 241, 241, 0.5); }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/reauthenticateForm/reauthenticateForm.component.scss
// module id = ./src/app/components/reauthenticateForm/reauthenticateForm.component.scss
// module chunks = main